<template lang="html">
  <div
    class="dashboard-background-container flex-box horizontally-centered vertically-centered"
  >
    <div class="center-container modal-scroll-bar">
      <RemoteLogin
        @login-successfully="() => this.$router.push('/dashboard')"
      />
    </div>
  </div>
</template>

<script>
import RemoteLogin from 'src/components/authentication/RemoteLogin.vue'

export default {
  components: { RemoteLogin }
}
</script>

<style lang="scss">
.dashboard-background-container {
  background: rgba(0, 0, 0, 0.6);
  min-height: 100vh;

  .center-container {
    width: fit-content;
    background-color: white;
    border-radius: 16px;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    overflow-x: hidden;
    margin: auto;

    .remote-login {
      background: none !important;
    }

    .sign-up-container {
      max-width: calc(min(574px, 100vw));
    }

    .login-container {
      max-width: calc(min(394px, 100vw))
    }
  }
}

.modal-scroll-bar {
  scrollbar-width: thin;
  scrollbar-color: #dddddd;

  &::-webkit-scrollbar {
    width: 4px;
    height: 40px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-button {
    width: 20px;
  }

  &::-webkit-scrollbar-track {
    margin-bottom: 5vh;
    margin-top: 5vh;
  }
}
</style>
